import React, { useRef, useEffect, useState } from "react";
import * as styles from "./ProjectSynopsis.module.scss";
import projectSynopsisImage1 from "../../../images/on-going-projects/srinivasa/synopsis-img-1.jpg";
import projectSynopsisImage2 from "../../../images/on-going-projects/srinivasa/synopsis-img-2.jpg";
import bgImage from "../../../images/on-going-projects/srinivasa/header-icon.png";

function ProjectSynopsis() {
  const leftSectionRef = useRef(null);
  const [activeSynopsisImage, setActiveSynopsisImage] = useState(0);
  const currentSynopsisImage = useRef(0);
  const isCurrentSection = useRef(false); 
  const synopsisContainerRef = useRef(null);
  const projSynopsisIntersectionObserver = useRef(null);
  let timer1 = useRef(null);
  let timer2 = useRef(null);
  
  // const currentSection = useRef(1);
  const isScrolled = useRef(false);

  // Add a ref to store the scroll timer
  const scrollTimer = useRef(null);

  function wheelFn(event) {
    event.preventDefault();

    // Prevent rapid multiple triggers by checking isScrolled
    if (isScrolled.current) return;

    // Set isScrolled to true to lock further scrolls
    isScrolled.current = true;

    // Only trigger scroll if deltaY is significant (avoid micro scrolls)
    const header1Height = document.querySelector(".header-nav").offsetHeight;
    const header2Height = document.querySelector("#srinivasa-header").offsetHeight;
    window.scrollTo({
      top: document.querySelector("#section-2").offsetTop - (header1Height + header2Height),
      behavior: "smooth",
    });

    if(document.querySelector("#section-2").getBoundingClientRect().top >= (header1Height + header2Height - 5) && document.querySelector("#section-2").getBoundingClientRect().top <= (header1Height + header2Height + 5)) {

    if (event.deltaY > 30) {
      if(currentSynopsisImage.current < 1) {
        currentSynopsisImage.current = currentSynopsisImage.current + 1;
        setActiveSynopsisImage(currentSynopsisImage.current);
      } else {
        window.scrollTo({
          top: document.querySelector("#section-3").offsetTop - 165,
          behavior: "smooth",
        });
      }
    } else if (event.deltaY < -30) {
      if(currentSynopsisImage.current > 0) {
        currentSynopsisImage.current = currentSynopsisImage.current - 1;
        setActiveSynopsisImage(currentSynopsisImage.current);
      } else {
        window.scrollTo({
          top: document.querySelector("#section-1").offsetTop - 165,
          behavior: "smooth",
        });
      }
    } else {
      // If deltaY is too small, unlock scrolling immediately
      isScrolled.current = false;
      return;
    }
  }

    // Reset isScrolled.current to false after a short delay
    if (scrollTimer.current) {
      clearTimeout(scrollTimer.current);
    }
    scrollTimer.current = setTimeout(() => {
      isScrolled.current = false;
    }, 1200); // 1.2 second delay, adjust as needed
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && window.IntersectionObserver) {
      projSynopsisIntersectionObserver.current = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting) {
            if(synopsisContainerRef.current) {
              synopsisContainerRef.current.classList.add(`${styles.show}`);
              synopsisContainerRef.current.classList.remove(`${styles.hide}`);
              showSynopsis();
            }
          }
          else {
            if(synopsisContainerRef.current) {
              synopsisContainerRef.current.classList.add(`${styles.hide}`);
              synopsisContainerRef.current.classList.remove(`${styles.show}`);
              hideSynopsis();
            }
          }
        }, {
          threshold: 0.5,
        });
      });
    }

    return () => {
      if(projSynopsisIntersectionObserver.current && leftSectionRef.current) {
        projSynopsisIntersectionObserver.current.unobserve(leftSectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (projSynopsisIntersectionObserver.current && leftSectionRef.current) {
      projSynopsisIntersectionObserver.current.observe(leftSectionRef.current);
    }
  }, [leftSectionRef.current]);

  function showSynopsis() {
    if(leftSectionRef.current) {
      synopsisContainerRef.current.style.display = "block";
    }
  }

  function hideSynopsis() {
    timer2.current = setTimeout(() => {
      if(synopsisContainerRef.current) {
        synopsisContainerRef.current.style.display = "none";
      }
    }, 100);
  }

  // function scrollFn(e, ) {
  //   currentSynopsisImage.current
  //   e.preventDefault();
  //   e.stopPropagation();
  //   window.scrollTo({
  //     top: document.querySelector("#section-2").offsetTop - 165,
  //     behavior: "smooth",
  //   });
  // }

  useEffect(() => {
    if(typeof document !== 'undefined') { 
      document.querySelector("#section-2").addEventListener('wheel', wheelFn);
    }

    return () => {
      clearTimeout(timer1.current);
      clearTimeout(timer2.current);
    }
  }, []);

  return (
    <>
      <div className={styles.projectSynopsisWeb} id="section-2">
        <div className={styles.leftSection} ref={leftSectionRef}>
          <div className={`${styles.synopsisContainer} ${isCurrentSection.current ? styles.show : styles.hide}`} ref={synopsisContainerRef}>
            {activeSynopsisImage === 0 && <div className={styles.synopsis1Title}>
              <img src={bgImage} alt="Project Synopsis" className={styles.bgImage} />
              <span>Project Synopsis</span>
              </div>}
            <div className={styles.synopsis1 + ' ' + (activeSynopsisImage === 0 ? styles.active : '')}>
              <div className={styles.synopsisHeading}>
                A TALL STATURED SHINING STAR
              </div>
              <div className={styles.synopsisContent}>
                Like a refreshing lyrical Green Oasis, Baashyaam's Srinivasa
                springs to life in the heart of the concrete chaos of West
                Mambalam.
                <br />
                <br />
                Subtle yet sophisticated, the 19-storey tall green tower stands
                proudly 197 feet tall and looms large over the neighbourhood in
                all its pristine glory. It showcases sweeping, uninterrupted
                panoramic views of the city from most of the apartments.
              </div>
            </div>
            <div className={styles.synopsis2 + ' ' + (activeSynopsisImage === 1 ? styles.active : '')}>
              <div className={styles.synopsisHeading}>
                A SUBTLE FACADE THAT SEAMLESSLY BLENDS WITH THE SURROUNDING
              </div>
              <div className={styles.synopsisContent}>
                The facade of the building is sleek and modern, interspersed with
                presence of greenery on all the floors and around the project.
                <br />
                <br />
                Alternating deck space on each floor creates a floating green
                imagery.
              </div>
            </div>
          </div>
        </div>
        <div className={styles.rightSection}>
          <img
            src={projectSynopsisImage1}
            alt="Project Synopsis"
            className={styles.projectSynopsisImage}
            style={{
            transform: `translateY(${activeSynopsisImage * 100 * -1}%)`,
            transition: 'transform 0.5s ease',
            }}
          />
          <img
            src={projectSynopsisImage2}
            alt="Project Synopsis"
            className={styles.projectSynopsisImage}
            style={{
              transform: `translateY(${activeSynopsisImage * 100 * -1}%)`,
              transition: 'transform 0.5s ease',
            }}
          />
        </div>
      </div>
      
      <div className={styles.projectSynopsisMobile} id="section-2">
      <div className={styles.synopsis1Container}>
        <img
          src={projectSynopsisImage1}
          alt="Project Synopsis"
          className={styles.projectSynopsisImage}
          style={{
           transform: `translateY(${activeSynopsisImage * 100 * -1}%)`,
           transition: 'transform 0.5s ease',
          }}
        />
        <div className={styles.overlay}>
        <div className={styles.synopsis1Content}>
          <div className={styles.synopsis1Title}>
            <img src={bgImage} alt="Project Synopsis" className={styles.bgImage} />
            <span>Project Synopsis</span></div>
          <div className={styles.synopsis1Heading}>A TALL STATURED SHINING STAR</div>
          <div className={styles.synopsis1Description}>
            Like a refreshing lyrical Green Oasis, Baashyaam's Srinivasa
            springs to life in the heart of the concrete chaos of West
            Mambalam.
          </div>
        </div>
        </div>
        </div>
        <div className={styles.synopsis2Container}>
        <img
          src={projectSynopsisImage2}
          alt="Project Synopsis"
          className={styles.projectSynopsisImage}
          style={{
            transform: `translateY(${activeSynopsisImage * 100 * -1}%)`,
            transition: 'transform 0.5s ease',
          }}
        />
        <div className={styles.overlay}>
        <div className={styles.synopsis2Content}>
          <div className={styles.synopsis2Heading}>A SUBTLE FACADE THAT SEAMLESSLY BLENDS WITH THE SURROUNDING</div>
          <div className={styles.synopsis2Description}>
            The facade of the building is sleek and modern, interspersed with
            presence of greenery on allthe floors and around the project.
          </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default ProjectSynopsis;
